import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getBanner, removeBanner } from 'slice/bannerSlice';
import AdminTable from 'common/AdminTable';
import { getUploadUrl } from 'utils/uploadUrl';

const BannerList = () => {
    const dispatch = useDispatch();
    const cartData = useSelector((state) => state.banner);

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Small Title',
            accessor: 'heading',
        },
        {
            Header: 'Main Heading',
            accessor: 'title',
        },
        {
            Header: 'Description',
            accessor: 'description',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                <img
                    src={getUploadUrl(row.original.image)}
                    alt={row.original.heading || row.original.title || 'Banner'}
                    width={100}
                />
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <Link to={`/khajuraho/banners/update/${row.original.id}`} className="btn btn-sm btn-info text-white mx-1">
                        Edit
                    </Link>
                    <button
                        className="btn btn-sm removebtn mx-1"
                        onClick={() => dispatch(removeBanner(row.original.id))}
                    >
                        Remove
                    </button>
                </>
            ),
        },
    ];

    useEffect(() => {
        dispatch(getBanner());
    }, [dispatch]);

    return (
        <>
            <div className="container-fluid mt-5">
                <div className="mainheadig mx-4">
                    <h4 className="text-white font-weight-bold">Banner List</h4>
                    <Link to="/khajuraho/banners/add" className="btn btn-light btn-sm font-weight-bold">Add New Banner</Link>
                </div>
                {cartData?.data?.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                ) : (
                    <p>No banner available</p>
                )}
            </div>
        </>
    );
};

export default BannerList;
